import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/schedule/$agendaItemId` activates the session-record
// column (col 2). The Schedule LAYOUT route (schedule.tsx) reads `$agendaItemId`
// from the leaf match and renders every column via ColumnLayout. Mirrors
// forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/schedule/$agendaItemId")({
  component: () => null,
})
